import React from 'react';
import styles from './FirstRowInfo.module.scss';
import infoIcon from './icons/info.png';

export default function () {
    return <img className={styles.infoIcon} alt={`info icon`} src={infoIcon} />;
}
